import { WizCommand } from '@wizeoo/akm-component-lib';
import { AugmentedUserDetails, UserWrapper, UserScenario, UserCriteria, User } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { UserVO } from '../../vo/user/user.vo';

/**
 * Appel info utilisateur (userInfo)
 */
export class UserInfoCmd extends WizCommand<UserWrapper> {
    
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  /** méthode appelée au retour de la commande */
  public sourceCallback: Function;

  /** mode d'appel (collecte des infos ou timestamp)  */
  public method: string = ExternalAPI.USER_INFO;

  /** retourne le wrapper pré-alimenté */
  public static getMapper(): UserWrapper {
    const wrapper: UserWrapper = new UserWrapper();
    wrapper.method = ExternalAPI.USER_INFO;
    wrapper.scenario = new UserScenario();
    wrapper.scenario.manageUserApps = true;
    wrapper.scenario.manageFeatures = true;
    wrapper.scenario.manageDomains = true;
    return wrapper;
  }

  public getUserInfo(callback: Function): UserInfoCmd {
    const wrapper: UserWrapper = UserInfoCmd.getMapper();
    this.sourceCallback = callback;
    this.configureRemote(ExternalAPI.USER, wrapper);
    return this;
  }

  /**
   * horodatage côté back sur connexion à une vision
   */
  public setUserTimeStamp(): UserInfoCmd { 
    const wrapper: UserWrapper = UserInfoCmd.getMapper();
    wrapper.method = ExternalAPI.USER_TIMESTAMP;
    this.method = ExternalAPI.USER_TIMESTAMP;

    let userLite: User = new User();
    userLite.id = this.model.connectedUser?.source.id;

    wrapper.entity = userLite; // this.model.connectedUser?.source;
    // passage des dom / bu / vision d'appel pour traçabilité
    wrapper.criteria = new UserCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.code = this.model.visionCode;

    this.configureRemote(ExternalAPI.USER, wrapper);
    return this;
  }


  /**
   * retour de service
   * gestion de retour selon la méthode d'appelle
   */
  public wizResult(): void {
    super.wizResult();
    if(this.method === ExternalAPI.USER_TIMESTAMP) {
      // rien
    } else {
      // alimentation du domaine actif
      if (this.result && this.result.token) {
        const info = this.result.token as AugmentedUserDetails;
        this.model.currentUser = info.internalUser;
        this.model.connectedUser = new UserVO(this.model, info.internalUser);
      }
      if (this.sourceCallback != null) {
        this.sourceCallback(this);
      }
    }
  }
}
